import { render, staticRenderFns } from "./personnelInformation.vue?vue&type=template&id=2396aadf&scoped=true"
import script from "./personnelInformation.vue?vue&type=script&lang=js"
export * from "./personnelInformation.vue?vue&type=script&lang=js"
import style0 from "./personnelInformation.vue?vue&type=style&index=0&id=2396aadf&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2396aadf",
  null
  
)

export default component.exports